import { render, staticRenderFns } from "./RenewalTab.vue?vue&type=template&id=69f76c37&"
import script from "./RenewalTab.vue?vue&type=script&lang=js&"
export * from "./RenewalTab.vue?vue&type=script&lang=js&"
import style0 from "./RenewalTab.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
